/** Keep in sync with `_one_hub_backend/src/casbin/normalizeRetiredRolePermissions.js`. */

import { normalizeAppManagementPermissions } from "./normalizeAppManagementPermissions";

const RETIRED_KEYS = new Set([
  "orders:cancel",
  "inventory:create",
  "inventory:delete",
  "catalog:import",
]);

const INVENTORY_MUTATION_LEGACY = new Set(["inventory:create", "inventory:delete"]);

/**
 * @param {string[]} permissions
 * @returns {string[]}
 */
export function normalizeRetiredRolePermissions(permissions) {
  const set = new Set((permissions || []).filter((p) => typeof p === "string" && p.trim()));

  if (set.has("orders:cancel")) {
    set.add("orders:update");
  }

  const hadInventoryMutationLegacy = [...set].some((k) => INVENTORY_MUTATION_LEGACY.has(k));
  for (const key of RETIRED_KEYS) {
    set.delete(key);
  }
  if (hadInventoryMutationLegacy && !set.has("inventory:update")) {
    set.add("inventory:update");
  }

  return [...set].sort();
}

/**
 * @param {string[]} permissions
 * @returns {string[]}
 */
export function finalizeRolePermissions(permissions) {
  return normalizeAppManagementPermissions(normalizeRetiredRolePermissions(permissions));
}
